module.exports = __webpack_public_path__ + "img/bg_wellve.65022522.png";